import script from "./DetailScheme.vue?vue&type=script&setup=true&lang=js"
export * from "./DetailScheme.vue?vue&type=script&setup=true&lang=js"

import "./DetailScheme.vue?vue&type=style&index=0&id=370ab35a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-370ab35a"]])

export default __exports__